import { createSlice } from "@reduxjs/toolkit";
import { registerUser } from "../actions/auth-actions";

interface InitialStateSlice {
  loading: boolean;
  userToken: null | string; // for storing the JWT
  error: null | any;
  success: boolean; // for monitoring the registration process.
}

interface SignupResponse {
  token_type: string;
  expires_in: number;
  access_token: string;
  refresh_token: string;
}

const initialState: InitialStateSlice = {
  loading: false,
  userToken: null,
  error: null,
  success: false,
};
interface extraReducerProps {
  [key: string]: any;
}
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: {
    [`${registerUser.pending}`]: (state: InitialStateSlice) => {
      state.loading = true;
      state.error = null;
    },
    [`${registerUser.fulfilled}`]: (state: InitialStateSlice, { payload }) => {
      const { expires_in, access_token, refresh_token } = payload;
      state.loading = false;
      state.success = true; // registration successful
      state.userToken = access_token;
      console.log("success:", payload);
      console.log("success:", refresh_token);
      console.log("success:", expires_in);
    },
    [`${registerUser.rejected}`]: (
      state: InitialStateSlice,
      { payload }: any
    ) => {
      state.loading = false;
      state.error = payload.message;
      console.log("error:", payload);
    },
  },
});

//   export const { nextDispatchOrderPage, prevDispatchOrderPage, resetStep } = BuyModalSlice.actions;
export default authSlice.reducer;
